import React from "react";
import {
  useNavigate,
  useParams,
} from "react-router-dom";
import titleize from "underscore.string/titleize";
import LiveEvents from "./../components/offer/live-events";
import { useSessionContext } from "../contexts/SessionContext";
import { CompanyContext } from "../contexts/CompanyContext";
import {
  Layouts,
} from "./../components";

function LiveEventEditor() {
  const navigate = useNavigate();
  let { offer_id, event_id } = useParams();
  const { selectedCompany } = React.useContext(CompanyContext);
  const { isPermitted, ACTIONS } = useSessionContext();

  if(!isPermitted(ACTIONS.WRITE_UPDATE_LIVE_EVENTS, selectedCompany.id)) {
    return (
      <div className="content-centered">
        You are not authorised to create/edit live events.
      </div>
    )
  }

  return (
    <div className="bg-white mvh-100">
      <Layouts.PageHeader left={titleize(event_id ? "Edit Live Event" : "New Live Event")} />
      <div className="px-3">
        <LiveEvents.Form offerId={offer_id} eventId={event_id} onSuccess={() => navigate(-1) }/>
      </div>
    </div>
  )
}

export default LiveEventEditor;